import { render } from "./FooterView.vue?vue&type=template&id=5ada8530&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=5ada8530&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ada8530"]])

export default __exports__